<template>
  <div>
    <div class="header flex-mid">
      <div class="flex-center fc-FFFFFF fs-20 fw-900">
        <img src="../assets/images/registor/official-logo.png" class="mr-6" />
        <span class="pt-2">happily.ai</span>
      </div>
    </div>
    <div class="p-10 fc-000000">
      <div v-if="steps === 'select'" class="modal-container">
        <div class="fw-900 fs-22">{{ $t("register.get_started_with") }}</div>
        <div
          @click.prevent="steps = 'one-team'"
          class="modal-box grid-2-img one-team"
          :class="{ 'show-img': hiddenCss }"
        >
          <div class="fs-14">
            <div class="flex">
              <div class="fw-700 fs-18 mb-6">
                {{ $t("register.set_up_one") }}
              </div>
              <div class="ban-free">{{ $t("register.FREE") }}</div>
            </div>
            <div>{{ $t("register.set_up_a") }}</div>
            <div>{{ $t("register.up_to_twenty") }}</div>
          </div>
          <img src="../assets/images/registor/ic_arrow.png" class="" />
        </div>
        <div
          @click.prevent="steps = 'many-team'"
          class="modal-box grid-2-img many-team"
          :class="{ 'show-img': hiddenCss }"
        >
          <div class="fs-14">
            <div class="fw-700 fs-18 mb-6 flex">
              {{ $t("register.set_up_many") }}
              <div class="ban-book">{{ $t("register.BOOK_A_TIME") }}</div>
            </div>
            <div>{{ $t("register.schedule_a_one") }}</div>
            <div>{{ $t("register.team_who_will") }}</div>
            <div>{{ $t("register.the_most_out") }}</div>
          </div>
          <img src="../assets/images/registor/ic_arrow.png" class="" />
        </div>
      </div>
      <div v-if="steps === 'one-team'" class="modal-container">
        <div class="modal-title">{{ $t("register.Setting_up_your") }}</div>
        <div class="fc-3C3C3C fs-13 mb-24">
          {{ $t("register.help_us_get") }}
        </div>
        <div class="input-titile">{{ $t("register.your_name") }}</div>
        <el-input
          placeholder="John Smith"
          v-model="oneTeamForm.name"
          class="form-48"
          :class="{ 'validate-input': validateOneTeamForm.name }"
        ></el-input>
        <div v-if="validateOneTeamForm.name" class="validate-worming">
          <div class="text">{{ $t("register.please_input_your_name") }}</div>
        </div>
        <div class="input-titile">{{ $t("register.your_work_email") }}</div>
        <el-input
          placeholder="john@example.com"
          class="form-48"
          v-model="oneTeamForm.email"
          :class="{
            'validate-input': validateOneTeamForm.email,
            'validate-input': validateOneTeamForm.detectEmail,
          }"
        ></el-input>
        <div v-if="validateOneTeamForm.email" class="validate-worming">
          <div class="text">{{ $t("register.please_input_your_work") }}</div>
        </div>
        <div
          v-else-if="validateOneTeamForm.detectEmail"
          class="validate-worming"
        >
          <div class="text">
            {{ $t("register.please_input_correct_email") }}
          </div>
        </div>
        <!-- <div class="input-titile">{{ $t("register.your_phone_number") }}</div>
        <el-input
          placeholder="+66 81 000 0000"
          class="form-48"
          v-model="oneTeamForm.phoneNumber"
          :class="{
            'validate-input': validateOneTeamForm.phoneNumber,
            'validate-input': validateOneTeamForm.detectPhoneNumber,
          }"
        ></el-input>
        <div v-if="validateManyTeamForm.phoneNumber" class="validate-worming">
          <div class="text">{{ $t("register.please_input_your_phone") }}</div>
        </div>
        <div
          v-else-if="validateOneTeamForm.detectPhoneNumber"
          class="validate-worming"
        >
          <div class="text">{{ $t("register.please_input_only_number") }}</div>
        </div> -->
        <div class="grid-2-50">
          <div class="mr-6">
            <div class="input-titile">{{ $t("register.company_name") }}</div>
            <el-input
              class="form-48"
              placeholder="ACME Inc"
              v-model="oneTeamForm.companyName"
              :class="{ 'validate-input': validateOneTeamForm.companyName }"
            ></el-input>
            <div
              v-if="validateOneTeamForm.companyName"
              class="validate-worming"
            >
              <div class="text">{{ $t("register.please_input_company") }}</div>
            </div>
          </div>
          <div class="ml-6">
            <div class="input-titile">
              {{ $t("register.language_preference") }}
            </div>
            <el-select
              v-model="oneTeamForm.language"
              filterable
              placeholder="Select"
              class="form-select-48"
            >
              <el-option
                class="text-dropdown"
                key="EN"
                label="English"
                value="EN"
              ></el-option>
              <el-option
                class="text-dropdown"
                value="TH"
                key="TH"
                label="ไทย"
              ></el-option>
            </el-select>
            <div v-if="validateOneTeamForm.language" class="validate-worming">
              <div class="text">
                Please input {{ $t("register.language_preference") }}
              </div>
            </div>
          </div>
        </div>
        <div class="grid-2-50">
          <div class="mr-16">
            <div class="input-titile">{{ $t("register.Location") }}</div>
            <el-select
              v-model="oneTeamForm.location"
              placeholder="Select"
              class="form-48"
              style="width: 100%"
            >
              <el-option
                v-for="item in locationOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div v-if="validateOneTeamForm.location" class="validate-worming">
              <div class="text">{{ $t("register.please_input_Location") }}</div>
            </div>
          </div>
          <div class="ml-8">
            <div class="input-titile">{{ $t("register.Time_Zone") }}?</div>
            <el-select
              v-model="oneTeamForm.timeZone"
              placeholder="Select"
              class="form-48"
              style="width: 100%"
            >
              <el-option
                v-for="item in timeZoneOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div v-if="validateOneTeamForm.timeZone" class="validate-worming">
              <div class="text">
                {{ $t("register.please_input_Time_Zonen") }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex mt-24">
          <label class="container">
            <input type="checkbox" v-model="oneTeamForm.termsConditions" />
            <span
              class="checkmark"
              :class="{ red: validateOneTeamForm.termsConditions }"
            ></span>
          </label>
          <div class="fs-14 fc-3C3C3C mt-3">
            {{ $t("register.i_agree_to") }}
            <span class="fc-32C2D5 cursor-pointer mt-3">{{
              $t("register.terms_and_conditions")
            }}</span>
          </div>
        </div>
        <div class="center mt-40 mb-20">
          <div
            @click.prevent="verifyEmail"
            class="buttom-meeting flex-mid cursor-pointer"
          >
            <div class="fs-20 fw-700">{{ $t("register.verify_my_email") }}</div>
            <div v-if="sendEmailStatus" class="icon-buttom-loading">
              <loading-even color="white"></loading-even>
            </div>
            <img
              v-else
              src="../assets/images/registor/ic_right_arrow.png"
              class="icon-buttom-primary"
            />
          </div>
        </div>
      </div>
      <div v-else-if="steps === 'confirm-email'" class="modal-container">
        <div class="modal-title">{{ $t("register.confirm_your_email") }}</div>
        <div class="fc-3C3C3C fs-13 mb-24">
          {{ $t("register.we_sent_you") }}
          <span class="fs-700">{{ oneTeamForm.email }}</span>
        </div>
        <div class="flex-center mb-24">
          <el-input
            v-numericOnly
            class="inputPincode"
            ref="FirstInput"
            style="width: 55px; font-size: 24px"
            maxlength="1"
            type="text"
            v-model="pincode.first"
            @focus="onFirstInputFocus"
            @keyup.native="onFirstInputChange"
            auto-complete="off"
          ></el-input>
          <el-input
            v-numericOnly
            class="inputPincode"
            ref="SecondInput"
            style="width: 55px; font-size: 24px; margin-left: 20px"
            maxlength="1"
            type="text"
            v-model="pincode.second"
            @focus="onSecondInputFocus"
            @keyup.native="onSecondInputChange"
            auto-complete="off"
          ></el-input>
          <el-input
            v-numericOnly
            class="inputPincode"
            ref="ThirdInput"
            style="width: 55px; font-size: 24px; margin-left: 20px"
            maxlength="1"
            type="text"
            v-model="pincode.third"
            @focus="onThirdInputFocus"
            @keyup.native="onThirdInputChange"
            auto-complete="off"
          ></el-input>
          <el-input
            v-numericOnly
            class="inputPincode"
            ref="ForthInput"
            style="width: 55px; font-size: 24px; margin-left: 20px"
            maxlength="1"
            type="text"
            v-model="pincode.four"
            @focus="onForthInputFocus"
            @keyup.native="onForthInputChange"
            @keyup.enter.native="submitForm('ruleForm2')"
            auto-complete="off"
          ></el-input>
        </div>
        <div class="fc-3C3C3C fs-13 mb-14">
          {{ $t("register.the_email_may") }}
        </div>
        <div class="center mt-30 mb-20">
          <div
            @click.prevent="verifyPinCode"
            class="buttom-meeting flex-mid cursor-pointer"
          >
            <div class="fs-20 fw-700">{{ $t("register.verify_my_email") }}</div>
            <div v-if="verifyStatus" class="icon-buttom-loading">
              <loading-even color="white"></loading-even>
            </div>
            <img
              v-else
              src="../assets/images/registor/ic_right_arrow.png"
              class="icon-buttom-primary"
            />
          </div>
        </div>


        
        <div class="flex-mid mt-36">
          <div @click.prevent="steps = 'one-team'" class="go-back mr-20">
            {{ $t("register.go_back") }}
          </div>
          <div  @click.prevent="reSendCode" class="go-back blue ml-20">
            {{ $t("register.resend_code") }}</div>
        </div>
        <div class="center mail-background"></div>
      </div>
      <div v-else-if="steps === 'many-team'" class="modal-container">
        <div class="modal-title">{{ $t("register.Schedule_a_time_with") }}</div>
        <div class="fc-3C3C3C fs-15 mb-24">
          {{ $t("register.Setting_up_multiple_teams") }}
        </div>
        <div class="input-titile">{{ $t("register.your_name") }}</div>
        <el-input
          placeholder="John Smith"
          class="form-48"
          v-model="manyTeamForm.name"
          :class="{ 'validate-input': validateManyTeamForm.name }"
        ></el-input>
        <div v-if="validateManyTeamForm.name" class="validate-worming">
          <div class="text">{{ $t("register.please_input_your_name") }}</div>
        </div>
        <div class="input-titile">{{ $t("register.your_work_email") }}</div>
        <el-input
          class="form-48"
          placeholder="john@example.com"
          v-model="manyTeamForm.email"
          :class="{
            'validate-input': validateManyTeamForm.email,
            'validate-input': validateManyTeamForm.detectEmail,
          }"
        ></el-input>
        <div v-if="validateManyTeamForm.email" class="validate-worming">
          <div class="text">{{ $t("register.please_input_your_work") }}</div>
        </div>
        <div
          v-else-if="validateManyTeamForm.detectEmail"
          class="validate-worming"
        >
          <div class="text">
            {{ $t("register.please_input_correct_email") }}
          </div>
        </div>
        <div class="input-titile">{{ $t("register.your_phone_number") }}</div>
        <el-input
          class="form-48"
          placeholder="+66 81 000 0000"
          v-model="manyTeamForm.phoneNumber"
          :class="{
            'validate-input': validateManyTeamForm.phoneNumber,
            'validate-input': validateManyTeamForm.detectPhoneNumber,
          }"
        ></el-input>
        <div v-if="validateManyTeamForm.phoneNumber" class="validate-worming">
          <div class="text">{{ $t("register.please_input_your_phone") }}</div>
        </div>
        <div
          v-else-if="validateManyTeamForm.detectPhoneNumber"
          class="validate-worming"
        >
          <div class="text">{{ $t("register.please_input_only_number") }}</div>
        </div>
        <div class="grid-2-50">
          <div class="mr-8">
            <div class="input-titile">{{ $t("register.company_name") }}</div>
            <el-input
              class="form-48"
              placeholder="ACME Inc"
              v-model="manyTeamForm.companyName"
              :class="{ 'validate-input': validateManyTeamForm.companyName }"
            ></el-input>
            <div
              v-if="validateManyTeamForm.companyName"
              class="validate-worming"
            >
              <div class="text">{{ $t("register.please_input_company") }}</div>
            </div>
          </div>
          <div class="ml-8">
            <div class="input-titile">
              {{ $t("register.how_many_people") }}?
            </div>
            <!-- <el-select
              v-model="manyTeamForm.language"
              placeholder="Select"
              class="form-48"
              style="width: 100%"
            >
              <el-option
                v-for="item in LanguageOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div v-if="validateManyTeamForm.language" class="validate-worming">
              <div class="text">
                {{ $t("register.please_input_language") }}
              </div>
            </div> -->
            <el-input
              type="number"
              class="form-48"
              placeholder="150"
              v-model="manyTeamForm.people"
              :class="{ 'validate-input': validateManyTeamForm.people }"
            ></el-input>
            <div v-if="validateManyTeamForm.people" class="validate-worming">
              <div class="text">
                {{ $t("register.please_input_number_of") }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="input-titile">
            {{ $t("register.what_would_you_like") }}?
          </div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            :placeholder="$t('register.i_want_to')"
            v-model="manyTeamForm.achieve"
            :class="{ 'validate-input': validateManyTeamForm.achieve }"
          ></el-input>
          <div v-if="validateManyTeamForm.achieve" class="validate-worming">
            <div class="text">
              {{ $t("register.please_input_your_achieve") }}
            </div>
          </div>
        </div>
        <div class="flex mt-16">
          <label class="container">
            <input type="checkbox" v-model="manyTeamForm.termsConditions" />
            <span
              class="checkmark"
              :class="{ red: validateManyTeamForm.termsConditions }"
            ></span>
          </label>
          <div class="fs-14 fc-3C3C3C mt-3">
            {{ $t("register.i_agree_to") }}
            <span class="fc-32C2D5 cursor-pointer mt-3">{{
              $t("register.terms_and_conditions")
            }}</span>
          </div>
        </div>
        <div class="center mt-40">
          <div
            @click.prevent="meeting"
            class="buttom-meeting flex-mid cursor-pointer"
          >
            <div class="fs-20 fw-700">{{ $t("register.book_a_meeting") }}</div>
            <img
              src="../assets/images/registor/ic_event.png"
              class="icon-buttom"
            />
          </div>
          <div class="go-back mt-36">
            <span @click.prevent="getBack('select')">{{
              $t("register.go_back")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "user-registration",
  components: {
    loadingEven: require("./even/loading").default,
  },
  computed: {
     timeZoneOption() {
      return this.$store.getters["register/timeZoneOption"];
    },
    locationOption() {
      return this.$store.getters["register/locationOption"];
    },
    verifyStatus(){
       return this.$store.getters["authen/loading"];
    }
  },
  watch:{
      verifyStatus(){
      if (this.verifyStatus==true) {
        this.steps="confirm-email"
      }
    }
  },
  created(){
    this.$store.dispatch("register/getTimezone", this.user);
    this.$store.dispatch("register/rewardMaster", this.user);
    if (this.verifyStatus==true) {
        this.steps="confirm-email"
      }
    
  },
  data() {
    
    return {
      steps: "select",
      //verifyStatus:false,
      oneTeamForm: {
        name: null,
        email: null,
        phoneNumber: null,
        companyName: null,
        language: null,
        location: null,
        timeZone: null,
        termsConditions: false,
      },
      validateOneTeamForm: {
        name: false,
        email: false,
        detectEmail: false,
        phoneNumber: false,
        detectPhoneNumber: false,
        companyName: false,
        language: false,
        location: false,
        timeZone: false,
        termsConditions: false,
      },
      manyTeamForm: {
        name: null,
        email: null,
        phoneNumber: null,
        companyName: null,
        people: null,
        achieve: null,
        termsConditions: false,
      },
      validateManyTeamForm: {
        name: false,
        email: false,
        detectEmail: false,
        phoneNumber: false,
        detectPhoneNumber: false,
        companyName: false,
        people: false,
        achieve: false,
        termsConditions: false,
      },
      hiddenCss: true,
      pincode: {
        first: null,
        second: null,
        third: null,
        four: null,
      },
      sendEmailStatus: false,
      LanguageOption: [
        {
          lable: "Thai",
          value: "thai",
        },
        {
          lable: "Eng",
          value: "eng",
        },
      ],
    };
  },
  methods: {
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    meeting() {
      const value = [
        "name",
        "email",
        "phoneNumber",
        "companyName",
        "people",
        "achieve",
      ];
      for (let i = 0; i < value.length; i++) {
        this.validateManyTeamForm[value[i]] = true;
        let status = this.$utils(
          "watchingTrim",
          this.manyTeamForm[value[i]] || ""
        );
        if (status) {
          this.validateManyTeamForm[value[i]] = false;
        } else {
          this.validateManyTeamForm[value[i]] = true;
        }
      }
      if (!this.validateManyTeamForm.phoneNumber) {
        this.validateManyTeamForm.detectPhoneNumber = !this.$utils(
          "validateInt",
          this.manyTeamForm.phoneNumber
        );
      } else {
        this.validateManyTeamForm.detectPhoneNumber = true;
      }
      if (!this.validateManyTeamForm.email) {
        this.validateManyTeamForm.detectEmail = !this.$utils(
          "validateEmail",
          this.manyTeamForm.email
        );
      } else {
        this.validateManyTeamForm.detectEmail = true;
      }
      let validateData =
        !this.validateManyTeamForm.name &&
        !this.validateManyTeamForm.name &&
        !this.validateManyTeamForm.email &&
        !this.validateManyTeamForm.detectEmail &&
        !this.validateManyTeamForm.phoneNumber &&
        !this.validateManyTeamForm.detectPhoneNumber &&
        !this.validateManyTeamForm.people;
      // !this.validateManyTeamForm.achieve;

      if (this.manyTeamForm.termsConditions && validateData) {
        this.validateManyTeamForm.termsConditions = false;
        console.log("Meeting Success"); // TODO: Funstion set meeting!
      } else {
        this.validateManyTeamForm.termsConditions = true;
      }
    },
    verifyEmail() {
      const value = ["name", "email", "phoneNumber", "companyName", "language","location","timeZone"];
      for (let i = 0; i < value.length; i++) {
        this.validateOneTeamForm[value[i]] = true;
        let status = this.$utils(
          "watchingTrim",
          this.oneTeamForm[value[i]] || ""
        );
        if (status) {
          this.validateOneTeamForm[value[i]] = false;
        } else {
          this.validateOneTeamForm[value[i]] = true;
        }
      }
      if (!this.validateOneTeamForm.email) {
        this.validateOneTeamForm.detectEmail = !this.$utils(
          "validateEmail",
          this.oneTeamForm.email
        );
      } else {
        this.validateOneTeamForm.detectEmail = true;
      }

      let validateData =
        !this.validateOneTeamForm.name &&
        !this.validateOneTeamForm.name &&
        !this.validateOneTeamForm.email &&
        !this.validateOneTeamForm.detectEmail &&
        // !this.validateOneTeamForm.phoneNumber &&
        !this.validateOneTeamForm.detectPhoneNumber &&
        !this.validateOneTeamForm.language &&
        !this.validateOneTeamForm.location &&
        !this.validateOneTeamForm.timeZone &&
        !this.validateOneTeamForm.achieve;

      if (this.oneTeamForm.termsConditions && validateData) {
        this.sendEmailStatus = true;
        setTimeout(() => {
          localStorage.setItem("lang", this.oneTeamForm.language);
          this.validateOneTeamForm.termsConditions = false;
          this.$store.dispatch("register/register", this.oneTeamForm);
          //console.log("Data Success", this.oneTeamForm); // TODO: Funstion verify email!
          this.steps = "confirm-email";
          this.sendEmailStatus = false; // SetTimeout for mock this loading!
        }, 1000);
      } else {
        this.validateOneTeamForm.termsConditions = true;
      }
    },
    getBack(step) {
      this.hiddenCss = false;
      if (this.steps == "one-team") {
        for (const [key, value] of Object.entries(this.oneTeamForm)) {
          if (key === "termsConditions") {
            this.oneTeamForm[key] = false;
          } else {
            this.oneTeamForm[key] = null;
          }
        }
        for (const [key, value] of Object.entries(this.validateOneTeamForm)) {
          this.validateOneTeamForm[key] = false;
        }
      } else {
        for (const [key, value] of Object.entries(this.manyTeamForm)) {
          if (key === "termsConditions") {
            this.manyTeamForm[key] = false;
          } else {
            this.manyTeamForm[key] = null;
          }
        }
        for (const [key, value] of Object.entries(this.validateManyTeamForm)) {
          this.validateManyTeamForm[key] = false;
        }
      }
      this.steps = step;
      setTimeout(() => {
        this.hiddenCss = true;
      }, 200);
    },
    onFirstInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        if (this.$refs.FirstInput.value) this.$refs.SecondInput.select();
      }
    },
    onSecondInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        if (this.$refs.SecondInput.value) this.$refs.ThirdInput.select();
      } else {
        this.$refs.FirstInput.select();
      }
    },
    onThirdInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        if (this.$refs.ThirdInput.value) this.$refs.ForthInput.select();
      } else {
        this.$refs.SecondInput.select();
      }
    },
    onForthInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (!re.test(e.target.value)) {
        if (!this.$refs.ForthInput.value) this.$refs.ThirdInput.select();
      }
    },
    onFirstInputFocus() {
      if (this.$refs.FirstInput.value) this.$refs.FirstInput.select();
    },
    onSecondInputFocus() {
      if (this.$refs.SecondInput.value) this.$refs.SecondInput.select();
    },
    onThirdInputFocus() {
      if (this.$refs.ThirdInput.value) this.$refs.ThirdInput.select();
    },
    onForthInputFocus() {
      if (this.$refs.ForthInput.value) this.$refs.ForthInput.select();
    },
    verifyPinCode() {
      // this.verifyStatus=true
      let validatePincode =
        this.pincode.first &&
        this.pincode.second &&
        this.pincode.third &&
        this.pincode.four;

      if (validatePincode) {
      
        this.$store.dispatch("authen/loginpincode", {
        pincode:
          this.pincode.first +
          this.pincode.second +
          this.pincode.third +
          this.pincode.four,
        freetrial:true
      }).then(()=>{
        console.log("Login Success"); // TODO: Funstion verify email!
       // this.$router.push({ name: "setup-wizard" });
        // this.verifyStatus=false
      });
        
      }
    },
    reSendCode(){
      this.$store.dispatch("authen/login", {email: this.oneTeamForm.email,freetrial:true});
    }
  },
};
</script>

<style lang="scss" scoped>
.buttom-meeting {
  position: relative;
  background-color: #6c30cc;
  color: #fff;
  border-radius: 4px;
  height: 50px;
  &:hover > .icon-buttom-primary {
    right: 20px;
  }
}
.container {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  user-select: none;
}
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  border-radius: 4px;
  background-color: #e8e8e8;
  transition: background-color 0.3s;
  &::after {
    content: "";
    position: absolute;
    display: none;
  }
}
.checkmark.red {
  background-color: #f56c6c;
}
.container:hover input ~ .checkmark {
  background-color: #e8e8e8;
}
.container:hover input ~ .checkmark.red {
  background-color: #f56c6c80;
}
.container input:checked ~ .checkmark {
  background-color: #2196f3;
}
.container input:checked ~ .checkmark:after {
  display: block;
}
.container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.grid-2-img {
  display: grid;
  grid-template-columns: auto 50px;
}
.header {
  height: 60px;
  background-color: #6c30cc;
  box-shadow: 0px 2px 4px #00000029;
}
.modal-container {
  background-color: #fff;
  margin: 72px auto;
  padding: 32px 52px;
  border-radius: 8px;
  width: calc(540px - 64px);
  box-shadow: 0 0 12px #00000029;
}
.modal-box.one-team {
  background-image: url("../assets/images/registor/illus_setup_1@2x.png");
  background-size: 244px 167px;
  background-position: 214px 105px;
  &:hover {
    background-position: 214px 80px;
  }
}
.modal-box.many-team {
  background-image: url("../assets/images/registor/illus_setup_2@2x.png");
  background-size: 164px 127px;
  background-position: 260px 110px;
  &:hover {
    background-position: 260px 70px;
  }
}
.mail-background {
  background-image: url("../assets/images/registor/illus_confirm_email.png");
  height: 180px;
  background-repeat: no-repeat;
  background-position: 50% 30px;
  margin-bottom: -32px;
}
.modal-box.show-img {
  transition: background-position 0.6s;
}
.modal-box {
  border-radius: 8px;
  border: 1px solid #d1d1d1;
  width: calc(100% - (32px * 2));
  padding: 32px;
  margin-top: 24px;
  height: 120px;
  cursor: pointer;
  transition: box-shadow 0.6s;
  background-repeat: no-repeat;
  &:hover {
    box-shadow: 0 0 12px #00000029;
  }
}
.input-titile {
  font-size: 14px;
  font-weight: 700;
  margin: 12px 0 6px;
}
.grid-2-auto {
  gap: 16px;
}
.ban-book,
.ban-free {
  border-radius: 3px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 17px;
  margin: 0 0 0 18px;
  height: 12px;
}

.ban-free {
  background-color: #32c2d5;
}
.ban-book {
  background-color: #606060;
}
.go-back {
  font-size: 13px;
  font-weight: 700;
  color: #000;
  opacity: 0.4;
  cursor: pointer;
}
.go-back.blue {
  color: #32c2d5;
  opacity: 1;
}
.icon-buttom-loading {
  position: absolute;
  top: 6px;
  right: 20px;
}
.icon-buttom-primary {
  position: absolute;
  right: 30px;
  transition: right 0.3s;
}
.icon-buttom {
  position: absolute;
  right: 30px;
}
.modal-title {
  font-weight: 900;
  font-size: 22px;
  margin-bottom: 16px;
}
</style>

<style lang="scss">
.form-select-48 {
  width: 100%;
  > .el-input.el-input--suffix {
    height: 48px;
    > input {
      height: 48px;
    }
  }
}
</style>